import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {NullAsDefault} from 'views/Shared'
import {SelectWidget} from "../../../../AppLocals/custom/ReactSelectComponents";
import WorkspaceContext from "../../../WorkspaceContext";
import _ from "lodash"
import classNames from "classnames";


const FilterChip = ({active, onClick, children}) => (
    <button
        type="button"
        onClick={onClick}
        style={{minHeight: 30}}
        className={classNames(
            'px-3 py-1 flex flex-center flex-shrink-0 gap-1 rounded-lg text-sm font-semibold transition-all cursor-pointer',
            active
                ? 'bg-secondary-500 text-white'
                : 'background shadow-sm hover:shadow-md text-slate-600 border border-color-50 hover:border-secondary-500 hover:text-secondary-500'
        )}>
        {children}
    </button>
)

export const TeacherFilter = ({
                                  owner_id,
                                  owner_type,
                                  defaultValue,
                                  hashtagsFilter,
                                  value: filter = {
                                      hashtags: undefined,
                                      active: undefined,
                                  },
                                  onChange: setValues = NullAsDefault,
                              }) => {
    const t = useTranslate();
    const {organization} = useContext(WorkspaceContext);

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )
    const activeValue = filter?.active == null ? undefined : String(filter.active)
    const isAll = activeValue === undefined || activeValue === ''

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <div className="flex flex-col gap-1">
                <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                    {`${t('supervisory position')} `}
                </span>
                <SelectWidget
                    className="w-full"
                    name={"hashtags"}
                    value={filter.hashtags || undefined}
                    allowClear={true}
                    disabled={!!hashtagsFilter}
                    placeholder={t('click to select')}
                    onChange={(value) => {
                        handleChange("hashtags", value)
                    }}
                    options={_.get(organization, 'workspace_settings.courses.groups.teacher_groups', []).map(e => {
                        return {
                            key: 'hashtags.' + e,
                            value: e,
                            label: e,
                        }
                    })}
                />
            </div>
            <div className="flex flex-col gap-1">
                <span className="font-medium text-2xs text-slate-400 uppercase tracking-wider">
                    {t('status')}
                </span>
                <div className="flex flex-wrap gap-2">
                    <FilterChip active={isAll} onClick={() => handleChange('active', undefined)}>
                        {t('all')}
                    </FilterChip>
                    {[
                        {value: 0, label: 'temporarily inactive'},
                        {value: 1, label: 'active'},
                    ].map((e) => (
                        <FilterChip
                            key={e.value}
                            active={!isAll && activeValue === String(e.value)}
                            onClick={() => handleChange('active', String(e.value))}>
                            {t(e.label)}
                        </FilterChip>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default TeacherFilter
